// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"47":"8ae3e7f3e805246e95c4","160":"d54091ce66d10eceb424","384":"43443a1392f661152830","747":"27abe2f74e6c5cca8ec7","894":"5f3abf6763157a40bb17"}[chunkId] + ".js";
};